export function highlightField(resultset, fieldName) {
    if (resultset?.fieldsChangedList?.some(x => x === fieldName.toLowerCase()))
        return 'highlight-text'
    return '';
}